import React, { useContext, useState } from 'react'
import { Drawer, Button, Input, Form, Card, Modal, Upload } from 'antd'
import Rate from 'components/AccessibleRate'
import TextArea from 'antd/lib/input/TextArea'
import client from 'apollo'
import moment from 'moment'
// import FinLogo from '../../assets/images/logo-tagline-new.png'
import { AppContext } from 'AppContext'
import { CREATE_REVIEW_FEEDBACK_FORM } from 'modules/ReviewFeedbackForm/graphql/Mutation'
import Text from 'antd/lib/typography/Text'
import { UploadOutlined } from '@ant-design/icons'
import openNotification from 'utils/Notification'
import { sum } from 'lodash'
import FilterBackButton from 'assets/images/new-images/filter-back-button.svg'
import { IS_FEEDBACK_FORM_SUBMITTED } from '../graphql/Mutations'

const CloseTicketDrawer = ({ visible, onClose, closeTicket, ticketId }) => {
  const [isSatisfied, setIsSatisfied] = useState()
  const [form] = Form.useForm()
  const [fileList, setFileList] = useState([])
  const [skipLoader, setSkipLoader] = useState(false)

  const handleReopen = async () => {
    console.log('handleReopen called')

    try {
      const values = await form.validateFields()
      const payload = {
        status: 'REOPEN',
        reasonClose: values.reason,
        fileUrl: values?.fileUrl?.length ? values?.fileUrl : null,
      }
      form
        .validateFields()
        .then(async (values) => {
          let mb = 0
          if (payload?.fileUrl) {
            const totalSize = sum(payload?.fileUrl?.map((item) => item?.size))
            mb = totalSize / 1024 / 1024
          }
          if (mb >= 3) {
            openNotification('error', `You can't upload more than 3 MB file`)
          } else {
            await closeTicket(payload)
            form.resetFields() // ✅ reset form fields
            setFileList([])
            setIsSatisfied(true)
            onClose()
          }
        })
        .catch((info) => console.log('Validate Failed:', info))
    } catch (error) {
      console.log('Form validation failed:', error)
    }
  }

  const isSubmitFeedbackForm = async () => {
    try {
      setSkipLoader(true)
      const response = await client.mutate({
        mutation: IS_FEEDBACK_FORM_SUBMITTED,
        variables: { id: ticketId },
      })

      const { data } = response
      if (data?.isTicketFeedback?.success) {
        openNotification('success', data?.isTicketFeedback?.message)
      } else {
        openNotification(
          'error',
          data?.isTicketFeedback?.message || 'Failed to submit feedback form.'
        )
      }
    } catch (error) {
      console.error('Error submitting feedback form:', error)
      openNotification(
        'error',
        'Something went wrong while checking feedback form submission.'
      )
    } finally {
      setSkipLoader(false)
      onClose()
    }
  }
  const {
    state: { currentUser },
  } = useContext(AppContext)

  const SubmitResponse = (values) => {
    client
      .mutate({
        mutation: CREATE_REVIEW_FEEDBACK_FORM,
        variables: {
          data: {
            ClientCode: currentUser?.clientCode ? currentUser?.clientCode : '',
            UserName: currentUser?.userName ? currentUser?.userName : '',
            Email: currentUser?.email ? currentUser?.email : values.email,
            clientName:
              currentUser?.firstName && currentUser?.lastName
                ? `${currentUser.firstName} ${currentUser.lastName}`
                : values?.clientName,
            SubmitDate: moment().format('MM-DD-YYYY'),
            Response: JSON.stringify({
              onboarding_experience: values.onboarding_experience,
              understanding_needs: values.understanding_needs,
              investment_advice: values.investment_advice,
              execution_of_advice: values.execution_of_advice,
              communication: values.communication,
            }),
            Suggestion: values.suggestion,
          },
        },
      })
      .then((res) => {
        Modal.success({
          title: 'Thank You!',
          content: 'Your feedback has been successfully submitted.',
          centered: true,
          className: 'review-form-modal',
          onOk: () => {
            Modal.destroyAll()
            window.location.reload()
          },
        })
      })
      .catch((err) => {
        Modal.error({
          title: 'Submission Failed',
          content:
            'Something went wrong while submitting your feedback. Please try again.',
          centered: true,
          className: 'review-form-modal',
        })
      })
  }
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e
    }

    const newFileList = [...(e?.fileList || [])]
    if (newFileList.length > 6) {
      openNotification('error', 'Cannot upload more than 6 files')
      return newFileList.slice(0, 6)
    }
    return newFileList
  }
  const customProps = {
    multiple: true,
    onRemove: (file) => {
      const currentFileList = form.getFieldValue('fileUrl') || []
      const updatedFileList = currentFileList.filter(
        (item) => item.uid !== file.uid
      )
      form.setFieldsValue({ fileUrl: updatedFileList })
    },
    beforeUpload: (file, fileList) => {
      const currentFiles = fileList
      if (currentFiles.length > 6) {
        return Upload.LIST_IGNORE
      }
      setFileList(file)
      return false
    },
    fileList,
  }
  return (
    <Drawer
      title={null}
      headerStyle={{ display: 'none' }}
      closable={false}
      placement='right'
      // onClose={handleReopen}
      visible={visible}
      width={472}
    >
      <div
        style={{
          margin: '32px 0 50px 0',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <div
          onClick={async () => {
            await onClose()
            setIsSatisfied(null)
          }}
        >
          <img src={FilterBackButton} alt='FilterBackButton' />
        </div>
        <div
          style={{
            fontSize: '24px',
            fontWeight: '700',
            lineHeight: '28px',
            textAlign: 'left',
            color: '#000000',
            marginLeft: '16px',
          }}
        >
          Close Ticket
        </div>
      </div>

      <div style={{ padding: '0 16px' }}>
        <div style={{ fontSize: '16px', marginBottom: '20px' }}>
          Are you satisfied?
        </div>
        <div
          style={{
            display: 'flex',
            gap: '10px',
            marginBottom: '20px',
            justifyContent: 'space-between',
          }}
        >
          <Button
            type=''
            className={
              isSatisfied === true ? 'close-active' : 'close-notactive'
            }
            onClick={() => setIsSatisfied(true)}
          >
            Yes
          </Button>
          <Button
            type=''
            className={
              isSatisfied === false ? 'close-active' : 'close-notactive'
            }
            onClick={() => setIsSatisfied(false)}
          >
            No
          </Button>
        </div>
        {isSatisfied === true && (
          <>
            <Card
              className='close-ticket-card-review-form-body'
              style={{
                width: '100%',
                maxWidth: '600px',
                // boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                // borderRadius: '10px',
                // height: 'calc(100vh - 80px)',
                overflow: 'scroll',
                border: 'none',
                scrollbarWidth: 'none',
                marginBottom: '0px',
              }}
            >
              <Form layout='vertical' onFinish={SubmitResponse}>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // borderBottom: '1px solid #ccc',
                    paddingBottom:
                      window.location.pathname === '/review-form' ? '20px' : '',
                    marginBottom: '20px',
                  }}
                >
                  {window.location.pathname === '/review-form' ? (
                    //  <img src={FinLogo} width='40%' alt='Finideas Logo' />
                    ''
                  ) : (
                    <>
                      <span>Request for your Valuable Feedback.</span>
                    </>
                  )}
                </div>
                {window.location.pathname === '/review-form' && (
                  <>
                    <Form.Item
                      label={
                        <Text strong>
                          Client Name<span style={{ color: 'red' }}> *</span>
                        </Text>
                      }
                      name='clientName'
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter the client name',
                        },
                      ]}
                    >
                      <Input style={{ width: '520px' }} />
                    </Form.Item>

                    <Form.Item
                      label={
                        <Text strong>
                          Email<span style={{ color: 'red' }}> *</span>
                        </Text>
                      }
                      name='email'
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter your email address',
                        },
                        {
                          type: 'email',
                          message: 'Please enter a valid email address',
                        },
                      ]}
                    >
                      <Input style={{ width: '520px' }} />
                    </Form.Item>
                  </>
                )}

                <Form.Item
                  label={
                    <div>
                      <Text strong>
                        1. Onboarding Experience?
                        <span style={{ color: 'red' }}> *</span>
                      </Text>
                      <div>
                        How satisfied were you with the onboarding process,
                        including account setup and initial documentation?
                      </div>
                    </div>
                  }
                  name='onboarding_experience'
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: 'Please rate your onboarding experience',
                    },
                  ]}
                >
                  <Rate />
                </Form.Item>

                <Form.Item
                  label={
                    <div>
                      <Text strong>
                        2. Understanding Your Needs?
                        <span style={{ color: 'red' }}> *</span>
                      </Text>
                      <div>
                        How well did the advisor assess and understand your
                        financial goals, risk appetite, and investment
                        preferences during onboarding?
                      </div>
                    </div>
                  }
                  name='understanding_needs'
                  required={false}
                  rules={[
                    {
                      required: true,
                      message:
                        'Please rate how well your needs were understood',
                    },
                  ]}
                >
                  <Rate />
                </Form.Item>

                <Form.Item
                  label={
                    <div>
                      <Text strong>
                        3. Quality of Investment Advice?
                        <span style={{ color: 'red' }}> *</span>
                      </Text>
                      <div>
                        How satisfied are you with the quality and clarity of
                        the investment advice provided?
                      </div>
                    </div>
                  }
                  name='investment_advice'
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: 'Please rate the investment advice quality',
                    },
                  ]}
                >
                  <Rate />
                </Form.Item>

                <Form.Item
                  label={
                    <div>
                      <Text strong>
                        4. Execution of Advice?
                        <span style={{ color: 'red' }}> *</span>
                      </Text>
                      <div>
                        How would you rate the timeliness and accuracy of the
                        execution of the agreed investment strategies?
                      </div>
                    </div>
                  }
                  name='execution_of_advice'
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: 'Please rate the execution of advice',
                    },
                  ]}
                >
                  <Rate />
                </Form.Item>

                <Form.Item
                  label={
                    <div>
                      <Text strong>
                        5. Overall Coordination and Communication?
                        <span style={{ color: 'red' }}> *</span>
                      </Text>
                      <div>
                        How effective has the communication been between you and
                        your advisor throughout the onboarding and advisory
                        process?
                      </div>
                    </div>
                  }
                  name='communication'
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: 'Please rate the communication effectiveness',
                    },
                  ]}
                >
                  <Rate />
                </Form.Item>

                <Form.Item
                  label={<Text strong>Any other Suggestions?</Text>}
                  name='suggestion'
                >
                  <Input.TextArea rows={4} />
                </Form.Item>

                <Form.Item>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <Button
                      type='primary'
                      htmlType='submit'
                      style={{
                        width: '100%',
                        borderRadius: '8px',
                        padding: '8px',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      Submit
                    </Button>
                    <Button
                      htmlType='submit'
                      style={{
                        width: '100%',
                        borderRadius: '8px',
                        padding: '8px',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      onClick={() => isSubmitFeedbackForm()}
                      loading={skipLoader === true}
                    >
                      Skip
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </Card>
          </>
        )}
        {isSatisfied === false && (
          <>
            <Form form={form} layout='vertical'>
              <Form.Item
                label='Reason for not satisfied'
                name='reason'
                rules={[{ required: true, message: 'Please provide a reason' }]}
              >
                <TextArea
                  placeholder='We will reopen your ticket, please provide reason so that we can resolve the issue.'
                  rows={4}
                />
              </Form.Item>

              <Form.Item
                name='fileUrl'
                label='File'
                valuePropName='fileList'
                getValueFromEvent={normFile}
                rules={[
                  {
                    validator: (_, value) =>
                      value?.length > 6
                        ? Promise.reject(
                            new Error('Cannot upload more than 6 files')
                          )
                        : Promise.resolve(),
                  },
                ]}
              >
                <Upload name='attachment' listType='text' {...customProps}>
                  <Button>
                    <UploadOutlined /> Select file
                  </Button>
                </Upload>
              </Form.Item>

              {/* <Form.Item style={{ textAlign: 'center' }}>
      <Button type="primary" htmlType="submit">
        Reopen
      </Button>
    </Form.Item> */}
            </Form>
          </>
        )}
      </div>

      {/* Move buttons to the bottom */}
      {isSatisfied === false && (
        <div
          style={{
            position: 'absolute',
            bottom: '0',
            left: '0',
            width: '100%',
            // padding: '16px',
            backgroundColor: '#fff',
            // borderTop: '1px solid #f0f0f0',
            display: 'flex',
            gap: '20px',
            height: '56px',
            margin: '20px 0px',
          }}
        >
          <Button
            style={{
              width: '100%',
              borderRadius: '8px',
              padding: '8px',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => onClose()}
          >
            Cancel
          </Button>
          <Button
            type='primary'
            style={{
              width: '100%',
              borderRadius: '8px',
              padding: '8px',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={handleReopen}
          >
            Re-open
          </Button>
        </div>
      )}
    </Drawer>
  )
}

export default CloseTicketDrawer
